<!--
 * @Description:
 * @Author: Ryan.HH
 * @Date: 2020-04-28 13:48:28
 * @LastEditors: Ryan.HH
 * @LastEditTime: 2021-04-22 11:32:57
 -->
<style lang="scss">
  .aa{
    margin-bottom:50px;
    .van-cell{
      line-height: 22px;
    }
    .title{
      font-size:20px;
      margin:8px;
    }
    .box-s{
      padding:5px 0;
    }
    .complaint-page-mail-div{
      display: -webkit-flex;
      display: flex;
      margin-top: 11px;
      -webkit-flex-direction: row;
      flex-direction: row;
      -webkit-align-items: center;
      align-items: center;
      max-width: 100vw;
      width: 100vw;
      -webkit-flex-grow: 2;
      flex-grow: 2;
      font-size: 1rem;
      padding-left: 0;
      border: none;
      img{
        width: 1rem;
        margin-right: 10px;
        margin-left: 4px;
        vertical-align: middle;
      }
      label{
        font-weight: 400;
        font-size: .9rem;
        min-width: 25vw;
        margin-bottom: 0;
        color: #666;
        display: inline-block;
      }
    }
    .complaint-page-mail-second{
      margin-top: 5px;
      margin-bottom: 11px;
      margin-left: calc(1rem + 14px);
      font-weight: 400;
      font-size: .9rem;
      min-width: 25vw;
      margin-bottom: 0;
      color: #666;
      display: inline-block;
      a{
        color: #007bff;
      }
    }
    .van-cell--required::before{
      color:#f98514;
    }
    .btn{
      background-color: #f98514;
      border:1px solid #f98514;
    }
  }
</style>
<template>
  <div class="aa">
    <van-form label-width="7em" @submit="onSubmit" autocomplete="off">
      <h2 class="title">投诉人信息</h2>
      <van-field
        height="10px"
        v-model="name"
        required
        name="name"
        label="姓名"
        placeholder="请输入您的姓名"
      />
      <van-field
        v-model="phone"
        required
        type="tel"
        name="phone"
        label="联系电话"
        placeholder="请输入您的电话"
      />
      <van-field
        v-model="email"
        type="tel"
        name="email"
        label="联系邮箱"
        placeholder="请输入您的常用邮箱"
      />
       <h2 class="title">投诉信息</h2>
       <van-field
          readonly
          clickable
          required
          name="picker"
          :value="brandType"
          label="投诉公司/品牌"
          placeholder="点击选择要投诉的公司"
          @click="showPicker = true"
        />
        <van-popup v-model="showPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="columns"
            @confirm="onConfirm"
            @cancel="showPicker = false"
          />
        </van-popup>
        <van-field
          readonly
          clickable
          required
          name="picker"
          :value="feedbackType"
          label="投诉类型"
          placeholder="点击选择投诉类型"
          @click="showPicker1 = true"
        />
        <van-popup v-model="showPicker1" position="bottom">
          <van-picker
            show-toolbar
            :columns="problem"
            @confirm="onConfirm1"
            @cancel="showPicker1 = false"
          />
        </van-popup>
        <van-field
          v-model="remark"
          rows="10"
          autosize
          required
          label="投诉描述"
          type="textarea"
          maxlength="400"
          placeholder="请输入400字以内的问题描述以便于我们及时解决问题"
          show-word-limit
        />
        <van-field name="uploader" label="相关图片上传">
          <template #input>
            <van-uploader v-model="uploader"
            :after-read="afterRead"
             :max-count="4"
             accept="image/*"
             @delete="delImg"
             />
          </template>
        </van-field>
        <div class="van-hairline--top van-hairline--bottom box-s">
          <div class="complaint-page-mail-div m-b-5">
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2CAYAAAH7QlpLAAAABGdBTUEAALGPC/xhBQAACIVJREFUaAW9GluIVkV4Zs76UvjQZS/aQxaID2Y3tIgg11TUwCJJE9IgL/svqPgQ+BD0FBV0I1Njd9UCUzCNyATNNVKLilxLTTPUvMLqv7ualRTk7pnp++bfb3bmXOacs/tvA7vz3b/55vrNnJ8xq4StdWfDltoVROII9LXUKqyDUjcDAQRZTXMPFxpK+IcKImypO5fA0yTQVO8Qk0wSLoLmnjWEoE+76AYhgRpFTGwQwUy11k8A/1cMAYAaRFArVFKH0sfqdFg6lKg50lRKpccJLZdOJ4S7nyNFXTvMYNYWw0SfTt8Sh8IYiAU4fa21u5his0goWpMS0itWExSoJ6PdjUq6C7DTfF5QMFr0SEul9kUZiMuj7yeRDS2xAww3BQhE0Gg6JzpqaTFSBxlFMo7Di6NIONbaQ1P5gE1LhEGxBf7+hVbsQ0NRIYcQbaotHATibr60Sy8XM2UchdGP6ikrmrqMXhjKs+B9LRK0kqOAxGltWphXZpqG8R80dRnWsEJrTyFgF3Vik406MDoQsGTGOlRA1I9vapIKb0RZGjcxOVxYhljUvuUOmZBkpX6uOvMZyTm1V8mRtJBUJeheS8wFBc0ph9zwcP84lR0yIgEPHteeYDyaba64r9IBPGGj4aXyPjON1PqGxjAME9caGuSMXw2au2+vwLYLgMPW2o1KsUVEhlb0wHJxAjSeSMiucYbL1rqTSRPAlhuAxfya5q6PB3AXSnQGrbwBrRzhivZjox5hYirM6StHmfxiQaIIErF/IbJWW8Bx5nUCWmLhccZvcnrGnHu2URsOgmAKX1rejzQ9ythduGBSoyHt338lKHeNkwDOhA5U0M5gojpbWJoleeS9NJafrthEnEACHLX4JS1u5zcWAgv93C4H9yE4UzGyF3xCUZ7q/ceQZHshVSZgoL4z2jkAuWm8lqrsebAoChSOkyPvmBWwGxPFRS7gHzRPzI9x0wiwiYkFx5iY8VGaRCIddxOzztT6+rvwhEqU7CeiE35zvSPi23JR0N7j9NTXRDg7cTuGss6xZiFyMyQ3/UcOkuXBVy1uHAxubayhzRS5JrK4qE7QOiB1mpjES6PheYDbexLf64wUcBLBhrwcBncOdMsEaOJI4HXCX7tgfB0vdR0jWV/tddbXUv8sdNZWnwHigaHTotQ9rjLhiOrWic7yTBbXjIVxtrum1POERTGgmSBEgdlV8s1KMXOznvoMjprEAkk4nh5JPCcycLQWxkfnWUnCmMhBNxlWuPNpxi59a/AoEE02TGSYE/gcoSHbEeJiqnM2Iskp0QiNM1/y4ViwEStKm0wwno/6ftNP0M7ocCOh3PXVE9miMIa4dFAQd31edOGSB9V1iEBvjUkTCgjZVrfBK+lhqsv5TifYDMZqZ3iCeuw5rFje7pmJjiIgeGs0EyTKTMQvfumSrU3ZZcQxydSyQs7S7glx0wkUxWYUdLbDWLFzEUP0AZyNLuQMet6YUyc+NHAuQLHrBZ2Bu/7LnTr0Vi4fJKSYOlbYmdy7qKLf9zfZyVXDqv4UM6tuWNi1uTSGIAQJjxCCi7lDsJFbFQ9VwfM8S1gmMYXDLItBSpe/VFJFvUGq1oYpoQq/ylIWTWU4ZgaGOdwxm7HyD1lq+uEJhbRm5bLLr2Zp2Y608rTsbRWfWMiuaaad3xEzs+454hWBcWqmtxwUNM4QCcaNH4F1WpEHXzMsTFblnoUGjwLgaJ33mksK+BAKi/A2wovW9tXW1h3IXmwqwHknjaPG2SFI4yY5NAtJdUYyqq1hslRyu2/hQyrygWjqXoJrifSS6kxnSUo2TacV60c9JlX4PORfs32NsvWiMDS0B/pzp+DBJrb08tdZDY/qR/FBBaaHk4VvDDZPijYiFYcpELBgVdqlKFUPGLkDw3xZhvKToSwIX0OyeHh/FYF4ht6KsuU9Emrb3EBeO7AaplfqTcOjzviDLzI+cVXsggD2mDoEA/7T2z71VB5uTeKWySv5vO1hmlDqiOEdDRqQ/5kp4kHM3ML4ndMjVBdVF/bCE6L7rcaV8GMQYOyJkTRigeHtVoaqY6hTTizpZDzwnh+QpPUyueEOasug6soU5ZPsUwwNOSeZ3hTgfWeoQekW/nkmu6F5ZDKsYFvx9o9tt0VNYPjYkSfbsZV9sMrIFVA3j4zPh83DtlcebCpUHRgejHlfcGxjXvjy9162ZuaRybZiScitlVhgKsIGwfG0t7hVAdWl7Gt2HpmijenPXLjQD3rDcXe5foGpa7HPfaadmgcy1S4wULUYE343nFNt42RPnd9NYKz28WLCBQkYk9BPrwUV84qrU6mfz5iPl9d+mhzGBE/I+j05TWZo9D9+Y6rcEbOhacAbtgIxCUhkLw2bAzAsj6yOmZeH343RqkzoxBHbU2WjrrkL7UydH3Ch4Yt7XZnqY+1c/55HyZ+rb9u1KKZv1AS5d7HLGAYs4OJenSvih9Uir7XD0JaqmcQbdlDqWawD04d0oV8MVK0dVTUEwZjvWjowtI7BhW11B6t5K+YPrGR80ksJ9zF4+O54nanD8Y1l0JHibbup+yF6UjCBkcGsH52RXFaNb5B8zAyvGG4kvrcur7LNTPgYaLJ7ksOvhfpNi7Neog2qrr0/Wy2PjMcKrKdebGvSF87YiNl2sj5A2rIxGH8A8OQO50HXltEvk58/leuB19YjGJ8H4OUy+WdfIOQNjIzgMwGswjX4/ZBouWsMEH91RaMD9zR5FH5Jl+PFOuoDRwiavCL6FBuVQzxXYKSoP4pLuQ42mFlE+19qWEOBEMui13+f70KB2Yb0LtraMI8z+Qpk02Nt3lBhaNRpxcTLQam8jXa5ojYHHViSIwyWtTXcA5e9Rlhc4wEfB5n2GJAdaZJt+DQH8F/AuwCNPgnnzC/wiWk/ayofH2wQYD9W/gMvs2D7mGMKygAAAABJRU5ErkJggg==" alt="">
            <label class="complaint-page-mail-label">如有相关其他凭据，请以附件形式发送至邮箱</label>
          </div>
          <label class="complaint-page-mail-second"><a href="mailto:customerexperience@fosunholiday.com?subject=Foliday_投诉反馈">customerexperience@fosunholiday.com</a>，我们将妥善处理。</label>
        </div>
      <div style="margin: 16px;">
        <van-button class="btn" round block type="info" native-type="submit" :loading="loading" :disabled="loading">提交</van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import { Popup, Picker, Uploader } from 'vant';
import { ua } from '@/utils/UA';

export default {
  name: 'complain',
  mixins: [],
  data() {
    return {
      name: '',
      phone: '',
      email: '',
      brandType: '',
      feedbackType: '',
      remark: '',
      uploader: [],
      columns: [],
      problem: [],
      imgArr: [],
      showPicker: false,
      showPicker1: false,
      loading: false,
      submitDebounce: null,
    };
  },
  components: {
    VanPopup: Popup,
    VanPicker: Picker,
    VanUploader: Uploader,
  },
  props: {

  },
  created() {
    this.init();
  },
  mounted() {

  },
  // brandType: "ATLANTIS"
  // email: ""
  // feedbackType: "LOGIN"
  // name: "阿萨大"
  // phone: "1231231"
  // remark: "asdasda"
  methods: {
    async init() {
      const resp = await this.getAjax('https://api.fosunholiday.com/api/feedback/CRM_FEEDBACK_BRANDTYPE');
      // console.log('resp', resp);
      if (resp.responseCode === '0') {
        Object.keys(resp.data).forEach((key) => {
          if (Object.prototype.hasOwnProperty.call(resp.data, key)) {
            this.columns.push({
              text: resp.data[key],
              label: key,
            });
          }
        });
      }
      const res = await this.getAjax('https://api.fosunholiday.com/api/feedback/CRM_FEEDBACK_FEEDBACKTYPE');
      if (res.responseCode === '0') {
        Object.keys(res.data).forEach((key) => {
          if (Object.prototype.hasOwnProperty.call(res.data, key)) {
            this.problem.push({
              text: res.data[key],
              label: key,
            });
          }
        });
      }
      console.log(this.columns);
      // problem
    },
    delImg(a, index) {
      console.log(a, index);
      this.imgArr.splice(index, 1);
      console.log(this.imgArr);
    },
    afterRead(file) {
      console.log(file);
      file.status = 'uploading';
      file.message = '上传中...';
      const imgFile = new FormData();
      imgFile.append('uploadFiles', this.uploader[this.imgArr.length].file);
      const header = {
        'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundaryRBdyPre7P5OXfBXB',
      };
      this.postAjax('https://api.fosunholiday.com/api/feedback/images', imgFile, header).then((res) => {
        console.log(res);
        console.log(this.uploader);
        if (res.responseCode === '0') {
          this.imgArr.push(res.data);
          // this.uploader[0].file = res.data;
          file.status = 'success';
        } else {
          file.status = 'failed';
          file.message = '上传失败';
        }
      });
    },
    onConfirm(value) {
      // console.log(value);
      this.brandType = value.text;
      this.showPicker = false;
    },
    onConfirm1(value) {
      // console.log(value);
      this.feedbackType = value.text;
      this.showPicker1 = false;
    },
    onSubmit(values) {
      if (this.loading) {
        return;
      }

      if (this.submitDebounce) {
        clearTimeout(this.submitDebounce);
      }

      this.submitDebounce = setTimeout(() => {
        this.doSubmit(values);
      }, 300);
    },
    async doSubmit(values) {
      const {
        email, phone, name,
      } = values;
      if (name === '') {
        this.$toast('请输入姓名');
        return;
      }
      if (phone === '') {
        this.$toast('请输入电话号码');
        return;
      }
      if (phone.length < 6 || phone.length > 18) {
        this.$toast('请输入正确的电话号码,长度在6-18位之间');
        return;
      }
      const pattern = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
      if (email && !pattern.test(email)) {
        this.$toast('请输入正确的邮箱');
        return;
      }
      if (this.brandType === '') {
        this.$toast('请选择投诉公司/品牌');
        return;
      }
      if (this.feedbackType === '') {
        this.$toast('请选择投诉类型');
        return;
      }
      if (this.remark === '') {
        this.$toast('请输入投诉描述');
        return;
      }

      this.loading = true;
      const loadingToast = this.$toast.loading({
        message: '提交中...',
        forbidClick: true,
        duration: 0,
      });

      try {
        const brandTypeTxt = this.columns.filter(item => item.text === this.brandType)[0].label;
        const feedbackTypeTxt = this.problem.filter(item => item.text === this.feedbackType)[0].label;
        let channel;
        if (this.Prius.isInsideApp) {
          channel = ua.android ? 'android' : 'ios';
        } else {
          channel = 'h5';
        }

        const params = {
          brandType: brandTypeTxt,
          feedbackType: feedbackTypeTxt,
          remark: this.remark,
          name,
          email,
          phone,
        };
        if (this.imgArr.length !== 0) {
          this.imgArr.forEach((item, index) => {
            params[`resource${index + 1}`] = item;
          });
        }
        console.log(params);
        const res = await this.postAjax(`https://api.fosunholiday.com/api/feedback?channel=${channel}`, params);
        loadingToast.clear();
        if (res.responseCode === '0') {
          this.$toast.success('投诉成功');
          this.uploader = [];
          this.imgArr = [];
          this.name = '';
          this.phone = '';
          this.email = '';
          this.brandType = '';
          this.feedbackType = '';
          this.remark = '';
        } else {
          this.$toast.fail(res.message);
        }
      } catch (error) {
        loadingToast.clear();
        // this.$toast.fail('提交失败，请稍后重试');
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
